// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"94":"42ec7d5b","224":"363a530c","506":"e7cdf030","564":"7de50673","572":"3d366ef3","828":"35537b2e"}[chunkId] + ".js";
};